module.exports = {"522627001":"凤城街道","522627002":"邦洞街道","522627003":"社学街道","522627102":"坪地镇","522627103":"兰田镇","522627104":"瓮洞镇","522627105":"高酿镇","522627106":"石洞镇","522627107":"远口镇","522627108":"坌处镇","522627109":"白市镇","522627110":"渡马镇","522627111":"江东镇","522627112":"竹林镇","522627202":"注溪乡","522627203":"地湖乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522627.json
// module id = 2328
// module chunks = 0